import GBlogPostTags from './g-blog-post-tags.vue';

export default GBlogPostTags;
